import React, { useState } from "react";
import { FaPencilAlt } from "react-icons/fa";
import { Form, Button } from "react-bootstrap";

const Permissions = () => {
  const [permissions, setPermissions] = useState({
    cases: {
      newCase: true,
      caseEnclosures: true,
      cancelCase: true,
      listCasesArrivingToday: true,
      listCases: true,
      pickup: true,
      uploadCaseFiles: true,
      allowCaseNotes: false,
      disableCaseNotesOnReceived: false,
    },
    finances: {
      accountBalance: true,
      accountPayment: false,
      priceList: false,
      statements: true,
      displayEstimatedTotal: false,
      invoices: true,
    },
  });

  const handleToggle = (category, key) => {
    setPermissions((prev) => ({
      ...prev,
      [category]: { ...prev[category], [key]: !prev[category][key] },
    }));
  };

  const handleSave = () => {};

  return (
    <div style={{ padding: "3px", backgroundColor: "#ffffff", width: "100%" }}>
      <h3 style={{ color: "#4169E1" }}> Account Permissions</h3>

      {/* Cases Section */}
      <div
        style={{
          backgroundColor: "#f2f2f2",
          padding: "5px",
          borderRadius: "5px",
          marginBottom: "10px",
          color: "black",
          display: "inline-block",
          textAlign: "centre",
          width: "100%",
          borderTop: "3px solid #004aad",
        }}
      >
        <strong>Cases</strong>
        {Object.keys(permissions.cases).map((key) => (
          <div key={key} className="d-flex align-items-center">
            <Form.Check
              type="switch"
              id={key}
              label={key.replace(/([A-Z])/g, " $1").trim()}
              checked={permissions.cases[key]}
              onChange={() => handleToggle("cases", key)}
            />
          </div>
        ))}
        <Form.Select disabled={!permissions.cases.allowCaseNotes}>
          <option>Select a stage</option>
          <option>Stage 1</option>
          <option>Stage 2</option>
        </Form.Select>
      </div>

      {/* Finances Section */}

      <div
        style={{ padding: "3px", backgroundColor: "#ffffff", width: "100%" }}
      >
        <h3 style={{ color: "#4169E1" }}> Finances</h3>
      </div>
      <div
        style={{
          backgroundColor: "#f0f0f0",
          padding: "15px",
          borderRadius: "8px",
          width: "100%",
          borderTop: "3px solid #004aad",
          color: "black",
        }}
      >
        {Object.keys(permissions.finances).map((key) => (
          <div key={key} className="d-flex align-items-center">
            <Form.Check
              type="switch"
              id={key}
              label={key.replace(/([A-Z])/g, " $1").trim()}
              checked={permissions.finances[key]}
              onChange={() => handleToggle("finances", key)}
            />
          </div>
        ))}
      </div>

      {/* Save Button */}
      <Button
        onClick={handleSave}
        style={{
          backgroundColor: " #004aad",
          color: "#fff",
          marginTop: "10px",
        }}
      >
        <FaPencilAlt /> Save Permissions
      </Button>
    </div>
  );
};

export default Permissions;
